import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ROUTES } from 'src/app/constants/Routes';

interface MediaCreative {
  title: string;
  description: string;
  image: string;
  alt: string;
  category: string;
  href: string;
}

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
  standalone: false
})
export class MediaComponent implements OnInit {
  mediaCreatives: MediaCreative[] = [
    {
      title: 'iQ360 — Context Intelligence',
      description: 'See how connected data becomes timely, relevant engagement and action.',
      image: 'assets/images/media/iQ360_Post 4.jpg',
      alt: 'Varroc Connect iQ360 context intelligence and decision engine creative',
      category: 'iQ360',
      href: ROUTES.products_connectiq_context_based_messaging
    },
    {
      title: 'Unified SDK — Daily Mobility Intelligence',
      description: 'A daily mobility companion powered by the Unified Telematics SDK.',
      image: 'assets/images/media/Final_LinkedIn_Post 1.jpg',
      alt: 'Varroc Connect Unified Telematics SDK daily mobility intelligence creative',
      category: 'Unified SDK',
      href: ROUTES.products_unitedsdk
    },
    {
      title: 'SecureIQ — Connected Trust',
      description: 'Purpose-built security for connected mobility and IoT ecosystems.',
      image: 'assets/images/media/LinkedIn_post_Secure IQ.jpg',
      alt: 'Varroc Connect SecureIQ connected trust and cybersecurity creative',
      category: 'SecureIQ',
      href: ROUTES.products_connectiq_secureiq
    },
    {
      title: 'ConnectIQ for Industrial IoT',
      description: 'Connect industrial assets and data with enterprise applications.',
      image: 'assets/images/media/IIOT v6.jpg',
      alt: 'Varroc Connect IIoT intelligence layer for industrial assets and enterprise applications',
      category: 'IIoT',
      href: ROUTES.products_connectiq_iiot
    },
    {
      title: 'FleetIQ — Operational Intelligence',
      description: 'Turn fleet data into real-time operational visibility and smarter decisions.',
      image: 'assets/images/media/FleetiQ_Post 3 1.jpg',
      alt: 'Varroc Connect FleetIQ operational intelligence creative',
      category: 'FleetIQ',
      href: ROUTES.solutions_business_fleet
    },
    {
      title: 'ConnectIQ — Intelligence Layer',
      description: 'One intelligence layer connecting vehicles, people, devices, and systems.',
      image: 'assets/images/media/Connect IQ_v9.jpg',
      alt: 'Varroc Connect ConnectIQ intelligence layer ecosystem creative',
      category: 'ConnectIQ',
      href: ROUTES.products_connectiq
    }
  ];

  constructor(private titleService: Title, private meta: Meta) {}

  ngOnInit(): void {
    this.titleService.setTitle('Media Gallery | Varroc Connect');
    this.meta.updateTag({
      name: 'description',
      content: 'Explore Varroc Connect product creatives and learn more about our connected mobility, fleet, IoT, and security solutions.'
    });
    this.meta.updateTag({ property: 'og:title', content: 'Media Gallery | Varroc Connect' });
    this.meta.updateTag({
      property: 'og:description',
      content: 'Explore Varroc Connect product creatives and connected mobility solutions.'
    });
    this.meta.updateTag({ property: 'og:url', content: 'https://varrocconnect.com/media' });
  }
}
